<template>
  <div>
    <Forms ref="frmSinisterScheduling"
      :title="$lang.Sinister.Scheduling.TitleForm"
      :showHelp="true"
      :showClearButton="false"
      :showSearchButton="false">
      <Alerts ref="alert"/>
      <SinisterHeader ref="SinisterHeader"/>
      <div class="form-group row"><div class="col-md-12"><hr></div></div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="cbxSchedulingType"><small v-show="form.schedulingTypeID.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.SchedulingType}}:</label>
          <div class="input-group">
            <b-form-select name="cbxSchedulingType"
                          v-model="form.schedulingTypeID.value"
                          :options="form.schedulingTypeID.options"
                          :state="form.schedulingTypeID.state"
                          :disabled="isCompleted"
                          class="mb-3">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtDateScheduling"><small v-show="form.dateScheduling.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.SchedulingDate}}:</label>
          <div class="input-group">
            <datepicker name="txtDateScheduling" v-model="form.dateScheduling.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-3">
          <label for="cbxScheduledWith"><small v-show="form.scheduledWith.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.ScheduledWith}}:</label>
          <div class="input-group">
            <b-form-select name="cbxScheduledWith"
                          v-model="form.scheduledWith.value"
                          :options="form.scheduledWith.options"
                          :state="form.scheduledWith.state"
                          :disabled="isCompleted"
                          class="mb-3">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxExpert"><small v-show="form.expertID.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.Expert}}:</label>
          <div class="input-group">
            <b-form-select name="cbxExpert"
                          v-model="form.expertID.value"
                          :options="getAllExpert"
                          :state="form.expertID.state"
                          :disabled="isCompleted"
                          class="mb-3">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtInstructions"><small v-show="form.description.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.Instructions}}:</label>
          <b-form-textarea name="txtInstructions"
                          v-model="form.description.value"
                          :placeholder="$lang.Sinister.Scheduling.PlaceholderInstructions"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"
                          :disabled="isCompleted"/>
        </div>
        <div class="col-md-6">
          <label for="txtObservations"><small v-show="form.observations.required" class="text-danger">*</small> {{$lang.Sinister.Scheduling.Observations}}:</label>
          <b-form-textarea id="txtObservations"
                          name="txtObservations"
                          v-model="form.observations.value"
                          :placeholder="$lang.Sinister.Scheduling.PlaceholderEnterObservations"
                          :rows="form.observations.rows"
                          :size="form.observations.maxlength"
                          :noResize="form.observations.noResize"
                          :disabled="isCompleted"/>
        </div>
      </div>

      <div class="form-group row pb-3">
        <div class="col-md-12 text-left force-border-bottom pl-3" v-if="hasRole(this.roles.RW_REG_TABSCHEDULING)" v-show="!isCompleted">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSave"><i class="fa fa-check-circle"></i> {{$lang.Common.Buttons.Save}} </button>&nbsp;
          <button type="button" class="btn btn-default btn-sm text-secundary" v-on:click="onClear"><i class="fa fa-minus-circle"></i> {{$lang.Common.Buttons.Clear}} </button>&nbsp;
        </div>
      </div>

      <Tables ref="tableGrid"
        :columns="['Data',
                   'Situação',
                    'Forma',
                    'Agedado com',
                    'Perito',
                    'Status',
                    $lang.Common.DataTable.ActionDate,
                    $lang.Common.DataTable.AccountAction,
                    $lang.Common.DataTable.Actions]"
        :showSearch="false"
        :showPrint="false"
        :showDownload="false"
        :showFullscreen="false"
        v-on:Load="onLoad">
        <tr v-for="obj in this.objList" v-bind:key="obj.ID">
          <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateScheduling" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.schedulingStatus.name"  />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.schedulingType.name" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.schedulingContact.name" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.expert ? obj.expert.name : ''"  />
          <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
          <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
          <TableColumn :IsActionsButtons="true" :HasDelete="false" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)"  :status="obj.status" />
        </tr>
      </Tables>

     </Forms>
  </div>
</template>
<script>
import SinisterScheduling from './sinisterscheduling.js'

export default SinisterScheduling
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/scheduling/sinisterscheduling.vue